export enum TickerValueFormat {
    CURRENCY,
    PERCENTAGE
}